import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=4c909a40&scoped=true"
import script from "@/views/Subjects/Template.ts?vue&type=script&lang=ts&external"
export * from "@/views/Subjects/Template.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Subjects/templates.scss?vue&type=style&index=0&id=4c909a40&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c909a40",
  null
  
)

export default component.exports